module.exports = __webpack_public_path__ + "img/s6.cfa390c8.jpg";